<div class="header">
  <!-- Header left -->
  <div class="left">
    <!-- Category name -->
    <div class="category">{{ project.title }}</div>
  </div>

  <div class="menu"></div>

  <div class="right"></div>
</div>
